import useSWR from 'swr';
import { fetcher, useUser } from 'shared/helpers/axios';

/**
 * Custom hook to fetch and track user's consortiums
 * @returns {Object} { consortia, count, isLoading, error, mutate }
 */
export const useUserConsortia = () => {
  const { user } = useUser();
  const { data, error, isLoading, mutate } = useSWR(
    user?.id ? `/consortium/consortiums/?member=${user.id}` : null,
    fetcher,
    {
      // Disabled auto-refresh to prevent rate limiting
      // Use mutate() to manually refresh when needed
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60000, // 1 minute
      shouldRetryOnError: false,
    }
  );

  const consortia = data?.results || [];
  const count = consortia.length;

  return {
    consortia,
    count,
    isLoading,
    error,
    mutate,
  };
};



